import request from "root/js/request";

export const getWBDynamicSubjectsById = async ({
  id,
  extra_fields,
  date_from,
  date_to,
  period,
} = {}) => {
  const response = await request({
    url: `wb_dynamic/subjects/${id}/`,
    method: "get",
    params: {
      extra_fields:
        // Логические операции в запросе делать не нужно, перед запросом выполняй то что нужно!!
        extra_fields ||
        [
          "avg_spp", // Данные по СПП и ценам
          "spp_prices", // Воронка продаж
          "funnel_data", // Взвешенное значение СПП
          "extra_data", // Дополнительные поля из карточки категории
        ].join(","),
      date_from,
      date_to,
      period,
      // ...(date_from && { date_from }),
      // ...(date_to && { date_to }),
      // ...(period && { period }),
    },
  });
  return response.data;
};
